import React from 'react'
import { Redirect } from 'react-router-dom'
import UnavailableMerchant from 'views/screens/errors/UnavailableMerchant'

const Merchant = () => {
  const link = window.location.hash
  let n = link.lastIndexOf('?')
  let merchantCode = link.substring(n + 1)
  merchantCode = merchantCode.replace(/=$/, '')

  if (merchantCode == null || merchantCode === '') return (<UnavailableMerchant />)

  if (merchantCode.includes('=&') === true) merchantCode = merchantCode.replaceAll('=&', '?')
  if (merchantCode.includes('&') === true) merchantCode = merchantCode.replaceAll('&', '?')
  return (<Redirect to={'/' + merchantCode} />)
}

export default Merchant
